import React, { useState } from "react";
import Button from "../../../shared/button";
import NotEligible from "./images/not-eligible.svg";
import LowScore from "./images/rejected-banner.png";
import NotMathced from "./images/details-not-matched.svg";
import CreditScoreBox from "../../credit-score-box";
import ErrorIcon from "./images/error-icon.svg";

import PropTypes from "prop-types";

import styles from "./styles.css";
import { LOAN_ERROR } from "../../../../constants/checkout-constants";
import { trackDesktopCustomEventsAU } from "../../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../../tracking/au.desktop-events";
import { getAbExpirementVariant } from "../../../../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../../../../constants/optimize-constants";
// import { useHistory } from "react-router";

const FinancingCfRejected = ({
    financeData,
    // updatePreAppovalLoanConnect,
    financeErrorResponse,
    handleEditcallback,
    inHouseFinanceEligibility,
    preApprovalOnFlyDesktop,
    startPreApprovalOnFlyConnect
}) => {
    const [isLoading, setIsLoading] = useState(false);
    // const history = useHistory();
    const { errorCode = LOAN_ERROR.DEFAULT, displayFlag, title = "", error } = financeErrorResponse || {};

    const { user: {firstName} } = financeData;
    const handleEditFinanceForm = async () => {
        const isOnFlyVariant = getAbExpirementVariant(preApprovalOnFlyDesktop, EXPERIMENT_TYPE.VARIANT_B);
        if (isOnFlyVariant && startPreApprovalOnFlyConnect) {
            startPreApprovalOnFlyConnect({
                entryPoint: "pre-approval-rejection-edit",
                isEditFlow: true,
                reloadOnClose: true
            });
            return;
        }
        setIsLoading(true);
        try {
            // await updatePreAppovalLoanConnect({submitted: false});
            setIsLoading(false);
            handleEditcallback(true);
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.EDIT_FLOW, {
                eventAction: "Flow_source",
                eventLabel: "Finance first rejection"
            });
            // history.push("/financing/get-pre-approval");
        } catch (err) {
            setIsLoading(false);
            // TODO: err
        }
    };

    const getDescriptionBox = (errCode) => {
        switch (errCode) {
        case LOAN_ERROR.RESIDENCY:
            return <CreditScoreBox img={NotEligible} heading="Not eligible" description="You should be an Australian citizen or permanant resident to be loan eligible." />;
        case LOAN_ERROR.UNEMPLOYED:
            return <CreditScoreBox img={NotEligible} heading="Not eligible" description="You should be employed to be eligible for loan." />;
        case LOAN_ERROR.CREDIT_SCORE:
            return <CreditScoreBox img={LowScore} heading="Low credit score" description="Your profile requires a higher credit score to be loan eligible."/>;
        case LOAN_ERROR.CREDIT_FILE:
            return <CreditScoreBox img={NotMathced} heading="Details didn’t match" description="Please double check your details are correct so we can verify your identity. Don’t worry, this won’t impact your credit score."/>;
        default:
            return null;
        }
    };

    const displayError = () => {
        if (inHouseFinanceEligibility) {
            if (displayFlag) {
                return (
                    <p styleName={"styles.message"}>
                        <br/>
                        {title && <React.Fragment><span styleName={"styles.sorryTextes"}>{title}</span><br/></React.Fragment>}
                        {error}
                    </p>
                );
            } else {
                return (
                    <p styleName={"styles.message"}>Sorry! Our lenders are unable to provide you with a loan.</p>
                );
            }
        } else {
            return (
                <React.Fragment>
                    {errorCode !== LOAN_ERROR.CREDIT_FILE && <p styleName={"styles.message"}>You have not been approved for a loan</p>}
                    {errorCode ?
                        getDescriptionBox(errorCode) :
                        <img styleName={"styles.errorIcon"} src={ErrorIcon} alt="You have not been approved for a loan" />}
                </React.Fragment>

            );
        }
    };

    return (
        <div className="container" styleName={"styles.outer"}>
            <div styleName={"styles.textWrap"}>
                <h2 styleName={"styles.contentHeader"}>Sorry {firstName || ""} ! </h2>
            </div>
            <div styleName={"styles.boxWrapper"}>
                {displayError()}
            </div>
            <span styleName={"styles.buttonWrapper"}>
                <Button text="EDIT FINANCE FORM" onClick={handleEditFinanceForm} isLoading={isLoading} />
            </span>
            { inHouseFinanceEligibility ?
                <p styleName={"styles.information"}>
                            Should you have any further questions, kindly reach out to our best-in-class team at <span>financing.au@cars24.com</span>,  we will be happy to further discuss your application.
                </p> :
                <p styleName={"styles.information"}>
                            For any queries related to loan profile approval get in touch with the Driva support team on <span>1300 755 494.</span>
                </p>
            }
        </div>
    );
};

FinancingCfRejected.propTypes = {
    errorCode: PropTypes.string,
    financeErrorResponse: PropTypes.object,
    handleEditcallback: PropTypes.func,
    content: PropTypes.object,
    financeData: PropTypes.object,
    inHouseFinanceEligibility: PropTypes.bool,
    updatePreAppovalLoanConnect: PropTypes.func,
    navigateToSummary: PropTypes.func,
    preApprovalOnFlyDesktop: PropTypes.object,
    startPreApprovalOnFlyConnect: PropTypes.func
};

export default FinancingCfRejected;
